var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"tab-content",class:{'blueprint-bg': _vm.blueprint, 'justify': _vm.justifyContent}},[(!!this.$slots.header === true)?_c('div',{staticClass:"tab-header"},[_c('div',{staticClass:"header"},[_vm._t("header")],2),_vm._v(" "),_vm._t("postheader")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }